import {useGetOfferListQuery} from "../../offer/api/get_offer_list";
import {useGetPropertyListQuery} from "../../property/api/get_property_list";

export const useReelInquiryFormData = (offerId?: number | null, propertyId?: number | null) => {
    const isOfferFetch = !!offerId && !propertyId;
    const isPropertyFetch = !!propertyId;

    const {data: offerData, isLoading: isOfferLoading} = useGetOfferListQuery(
        {
            page: 1,
            include_offer: isOfferFetch ? [offerId] : []
        },
        {
            skip: !isOfferFetch
        }
    );

    const {data: propertyData, isLoading: isPropertyLoading} = useGetPropertyListQuery(
        {
            include_property: isPropertyFetch ? [propertyId] : []
        },
        {skip: !isPropertyFetch}
    );

    const offer = offerData?.results[0];
    const property = propertyData?.results[0];

    return {
        vendor: isPropertyFetch ? property?.offer.vendor : offer?.vendor,
        offer: isPropertyFetch ? property?.offer : offer,
        property,
        isLoading: isOfferLoading || isPropertyLoading
    };
};
import {useGetOfferListQuery} from "../../offer/api/get_offer_list";
import {useGetPropertyListQuery} from "../../property/api/get_property_list";

export const useReelInquiryFormData = (offerId?: number | null, propertyId?: number | null) => {
    const isOfferFetch = !!offerId && !propertyId;
    const isPropertyFetch = !!propertyId;

    const {data: offerData, isLoading: isOfferLoading} = useGetOfferListQuery(
        {
            page: 1,
            include_offer: isOfferFetch ? [offerId] : []
        },
        {
            skip: !isOfferFetch
        }
    );

    const {data: propertyData, isLoading: isPropertyLoading} = useGetPropertyListQuery(
        {
            include_property: isPropertyFetch ? [propertyId] : []
        },
        {skip: !isPropertyFetch}
    );

    const offer = offerData?.results[0];
    const property = propertyData?.results[0];

    return {
        vendor: isPropertyFetch ? property?.offer.vendor : offer?.vendor,
        offer: isPropertyFetch ? property?.offer : offer,
        property,
        isLoading: isOfferLoading || isPropertyLoading
    };
};
